import PropTypes from "prop-types";
import { useFormContext } from "react-hook-form";

import { Button, PresetsStyled } from "./Presets.styled";

function Presets({ presets, name }) {
    const { setValue, watch } = useFormContext();
    const value = watch(name);

    return (
        <PresetsStyled>
            {presets?.map(item => (
                <Button
                    key={item}
                    onClick={event => {
                        event.preventDefault();
                        setValue(name, item, {
                            shouldDirty: true
                        });
                    }}
                    width={`${100 / presets.length}%`}
                    value={item}
                    active={parseInt(value, 10) === item}
                >
                    <span>€</span>
                    {item}
                </Button>
            ))}
        </PresetsStyled>
    );
}

Presets.defaultProps = {
    presets: [10, 25, 50, 75, 100]
};

Presets.propTypes = {
    name: PropTypes.string.isRequired,
    presets: PropTypes.arrayOf(PropTypes.number)
};

export default Presets;
